(function() {
  var PrescriptionMapKo, StepHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepHandler = App.loadClass('grower::handlers/placement/StepHandler');

  PrescriptionMapKo = App.loadClass('grower::viewmodels/placement/Prescription_Map');

  exports.PrescriptionMapHandler = (function(superClass) {
    extend(PrescriptionMapHandler, superClass);

    function PrescriptionMapHandler() {
      return PrescriptionMapHandler.__super__.constructor.apply(this, arguments);
    }

    PrescriptionMapHandler.prototype.inputSel = '';

    PrescriptionMapHandler.prototype.addValidationRules = function() {
      return this.validator.registerRule({
        selector: '.validate-int',
        text: '%s must be a whole number',
        func: (function(_this) {
          return function(elem) {
            var val;
            val = $(elem).val();
            return !val || (!isNaN(val) && String(parseInt(val)) === val);
          };
        })(this)
      });
    };

    PrescriptionMapHandler.prototype.getFieldAspect = function(fieldID, aspectID) {
      var aspectName, koData, retval;
      koData = this.stepKO.toJS();
      aspectName = this.taffyObjects.y_aspects({
        aspects_id: aspectID
      }).first().aspect_name;
      retval = {
        value: koData[this._autoAlias(aspectName)]
      };
      return retval;
    };

    PrescriptionMapHandler.prototype.setFieldAspect = function(fieldAspect) {};

    PrescriptionMapHandler.prototype.afterLoadLayout = function(sel, data) {
      var rxMapsID, rxPlansID;
      ko.cleanNode(this.parent.dialog.find('#spp_body')[0]);
      PrescriptionMapHandler.__super__.afterLoadLayout.call(this, sel, data);
      this.stepKO = new PrescriptionMapKo(this, this._getData());
      ko.applyBindings(this.stepKO, this.parent.dialog.find('#spp_body')[0]);
      rxMapsID = this.taffyObjects.y_aspects({
        aspect_name: 'Create Rx Maps'
      }).first().aspects_id;
      this.getInputEl({
        aspect: rxMapsID
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.create_rx_maps(!$(el).is('.active'));
        };
      })(this));
      this.getInputEl({
        aspect: -rxMapsID
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.create_rx_maps($(el).is('.active'));
        };
      })(this));
      rxPlansID = this.taffyObjects.y_aspects({
        aspect_name: 'Multi-Hybrid Rx Plan'
      }).first().aspects_id;
      this.getInputEl({
        aspect: rxPlansID
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.multihybrid_rx_plan(!$(el).is('.active'));
        };
      })(this));
      return this.getInputEl({
        aspect: -rxPlansID
      }).on('click', (function(_this) {
        return function(el) {
          return _this.stepKO.multihybrid_rx_plan($(el).is('.active'));
        };
      })(this));
    };

    PrescriptionMapHandler.prototype._getData = function() {
      var data, field_id, planting_max_pop, planting_min_pop, ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref2, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
      field_id = this.parent.taffyObjects.fields({
        selected: true
      }).first().id;
      planting_min_pop = (ref = (ref1 = this.parent.getFieldAspectByName(field_id, 'Planting Min Pop')) != null ? ref1.value : void 0) != null ? ref : null;
      planting_max_pop = (ref2 = (ref3 = this.parent.getFieldAspectByName(field_id, 'Planting Max Pop')) != null ? ref3.value : void 0) != null ? ref2 : null;
      data = {
        'create_rx_maps': (ref4 = (ref5 = this.parent.getFieldAspectByName(field_id, 'Create Rx Maps')) != null ? ref5.value : void 0) != null ? ref4 : null,
        default_min_pop: (ref6 = planting_min_pop != null ? planting_min_pop : (ref7 = this.response) != null ? (ref8 = ref7.data) != null ? ref8.company_min_pop : void 0 : void 0) != null ? ref6 : null,
        default_max_pop: (ref9 = planting_max_pop != null ? planting_max_pop : (ref10 = this.response) != null ? (ref11 = ref10.data) != null ? ref11.company_max_pop : void 0 : void 0) != null ? ref9 : null,
        'rx_map_min_pop': (ref12 = (ref13 = this.parent.getFieldAspectByName(field_id, 'Rx Map Min Pop')) != null ? ref13.value : void 0) != null ? ref12 : null,
        'rx_map_max_pop': (ref14 = (ref15 = this.parent.getFieldAspectByName(field_id, 'Rx Map Max Pop')) != null ? ref15.value : void 0) != null ? ref14 : null,
        'rx_map_max_num_pops': (ref16 = (ref17 = this.parent.getFieldAspectByName(field_id, 'Rx Map Max Num Pops')) != null ? ref17.value : void 0) != null ? ref16 : null,
        'rx_map_min_pop_diff': (ref18 = (ref19 = this.parent.getFieldAspectByName(field_id, 'Rx Map Min Pop Diff')) != null ? ref19.value : void 0) != null ? ref18 : null,
        'rx_map_max_pop_diff': (ref20 = (ref21 = this.parent.getFieldAspectByName(field_id, 'Rx Map Max Pop Diff')) != null ? ref21.value : void 0) != null ? ref20 : null,
        company_min_pop_diff: (ref22 = (ref23 = this.response) != null ? (ref24 = ref23.data) != null ? ref24.company_min_pop_diff : void 0 : void 0) != null ? ref22 : null,
        company_max_pop_diff: (ref25 = (ref26 = this.response) != null ? (ref27 = ref26.data) != null ? ref27.company_max_pop_diff : void 0 : void 0) != null ? ref25 : null,
        'multihybrid_rx_plan': (ref28 = (ref29 = this.parent.getFieldAspectByName(field_id, 'Multi-Hybrid Rx Plan')) != null ? ref29.value : void 0) != null ? ref28 : null
      };
      return data;
    };

    PrescriptionMapHandler.prototype._autoAlias = function(aspectName) {
      return aspectName.toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '_');
    };

    return PrescriptionMapHandler;

  })(StepHandler);

}).call(this);
